// src/App.tsx
import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { LoadingProvider } from "./contexts/LoadingContext";
import "./styles/globals.css";
import "./config/antdStaticTheme";
import Routes from "./routes";

const App: React.FC = () => {
  return (
    <LoadingProvider>
      <AuthProvider>
        <Routes />
      </AuthProvider>
    </LoadingProvider>
  );
};

export default App;
